import { boot } from 'quasar/wrappers';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';

export default boot(({ app, router }) => {
  Sentry.init({
    app,
    dsn: process.env.SENTRY_DSN,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracePropagationTargets: [
          'distribution-admin.pd.jobtarget.com',
          'distribution-admin.qa.pd.jobtarget.com',
          'distribution-admin.staging.pd.jobtarget.com',
          /^\//,
        ],
      }),
    ],

    trackComponents: true,
    tracesSampleRate: 1.0,
  });
});
